
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface TutorialNavigationProps {
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onSkip: () => void;
  isCompleting: boolean;
}

const TutorialNavigation: React.FC<TutorialNavigationProps> = ({ 
  currentSlide, 
  totalSlides, 
  onNext, 
  onSkip, 
  isCompleting 
}) => {
  const isLastSlide = currentSlide === totalSlides - 1;

  return (
    <div className="flex flex-col space-y-4">
      <Button 
        onClick={onNext} 
        className="w-full bg-[#e7fe52] text-black hover:bg-[#e7fe52]/90 py-6 rounded-xl"
        size="lg"
        disabled={isCompleting}
      >
        {isCompleting ? "Finishing..." : isLastSlide ? 'Start Using App' : 'Next'}
        {!isCompleting && <ArrowRight className="ml-2" />}
      </Button>

      {!isLastSlide && (
        <Button 
          onClick={onSkip}
          variant="ghost"
          className="text-muted-foreground hover:text-foreground"
          disabled={isCompleting}
        >
          Skip Tutorial
        </Button>
      )}
    </div>
  );
};

export default TutorialNavigation;
